// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-color-blue {
    color: blue;
  }
  
.ql-background-yellow {
  background-color: yellow;
}

.q1-editor {
  font-size: 22px | important;
}

.q1-container.q1-snow {
  font-size: 40px | important;
}

.results {
  all: unset;
  font-size: 14px;
  font-weight: normal;
  color: #333;
  text-align: left;
  /* Add additional styles as needed */
}

.indented {
  padding-left: 1em; /* Set padding to match the text-indent value */
  /* text-indent: -1em;  Set the negative value of padding-left */
  /* Add additional styles as needed */
}

.indented2 {
  padding-left: 2em; /* Set padding to match the text-indent value */
  /* text-indent: -1em;  Set the negative value of padding-left */
  /* Add additional styles as needed */
}

.indented3 {
  padding-left: 3em; /* Set padding to match the text-indent value */
  /* text-indent: -1em;  Set the negative value of padding-left */
  /* Add additional styles as needed */
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(0, 0, 0, 0.3);
  border-left-color: #000;
  border-radius: 50%;
  animation: spinner 1s linear infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}


.note-button {
  background-color: #3e81c3; 
  color: white;
  width: 100px;
  margin: 10px;
  padding: 2px 2px;
  border-radius: 2px;
  border: 1px solid white;
  cursor: pointer;
}

.note-button:hover {
  background-color: #2d618f; /* Darken the color on hover */
}


.note-button:active {
  transform: translateY(2px); /* Move the button down when it's clicked */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Add some shadow */
}


@keyframes slideInFromSide {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.sliding-text {
  opacity: 0; /* Initially hide the text */
  transform: translateX(-100%); /* Start off-screen to the left */
  animation: slideInFromSide 3s ease-in-out forwards;
}

.markdown-content * {
  font-weight: normal;
  font-size: 14px; /* Adjust the size as needed */
  /* Add other styles as needed */
}

.markdown-content a {
  color: blue !important; /* Use !important to override other styles if necessary */
  text-decoration: underline !important;
}

.message-input-container {
  display: flex;
  align-items: center; /* This vertically centers the children */
}

/* Add specific styles for bold text */
.markdown-content strong,
.markdown-content b {
  font-weight: bold; /* This will ensure bold text is displayed correctly */
}

.markdown-content p {
  margin-bottom: 1em; /* Adjust the value as needed to increase space */
}`, "",{"version":3,"sources":["webpack://./src/custom.css"],"names":[],"mappings":"AAAA;IACI,WAAW;EACb;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB,EAAE,+CAA+C;EAClE,+DAA+D;EAC/D,oCAAoC;AACtC;;AAEA;EACE,iBAAiB,EAAE,+CAA+C;EAClE,+DAA+D;EAC/D,oCAAoC;AACtC;;AAEA;EACE,iBAAiB,EAAE,+CAA+C;EAClE,+DAA+D;EAC/D,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;;AAGA;EACE,0BAA0B,EAAE,2CAA2C;EACvE,wCAAwC,EAAE,oBAAoB;AAChE;;;AAGA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,UAAU,EAAE,4BAA4B;EACxC,4BAA4B,EAAE,iCAAiC;EAC/D,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,eAAe,EAAE,8BAA8B;EAC/C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB,EAAE,yDAAyD;EACjF,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,yCAAyC;AAChE;;AAEA,sCAAsC;AACtC;;EAEE,iBAAiB,EAAE,sDAAsD;AAC3E;;AAEA;EACE,kBAAkB,EAAE,iDAAiD;AACvE","sourcesContent":[".ql-color-blue {\n    color: blue;\n  }\n  \n.ql-background-yellow {\n  background-color: yellow;\n}\n\n.q1-editor {\n  font-size: 22px | important;\n}\n\n.q1-container.q1-snow {\n  font-size: 40px | important;\n}\n\n.results {\n  all: unset;\n  font-size: 14px;\n  font-weight: normal;\n  color: #333;\n  text-align: left;\n  /* Add additional styles as needed */\n}\n\n.indented {\n  padding-left: 1em; /* Set padding to match the text-indent value */\n  /* text-indent: -1em;  Set the negative value of padding-left */\n  /* Add additional styles as needed */\n}\n\n.indented2 {\n  padding-left: 2em; /* Set padding to match the text-indent value */\n  /* text-indent: -1em;  Set the negative value of padding-left */\n  /* Add additional styles as needed */\n}\n\n.indented3 {\n  padding-left: 3em; /* Set padding to match the text-indent value */\n  /* text-indent: -1em;  Set the negative value of padding-left */\n  /* Add additional styles as needed */\n}\n\n.spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  border-left-color: #000;\n  border-radius: 50%;\n  animation: spinner 1s linear infinite;\n}\n\n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.note-button {\n  background-color: #3e81c3; \n  color: white;\n  width: 100px;\n  margin: 10px;\n  padding: 2px 2px;\n  border-radius: 2px;\n  border: 1px solid white;\n  cursor: pointer;\n}\n\n.note-button:hover {\n  background-color: #2d618f; /* Darken the color on hover */\n}\n\n\n.note-button:active {\n  transform: translateY(2px); /* Move the button down when it's clicked */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Add some shadow */\n}\n\n\n@keyframes slideInFromSide {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.sliding-text {\n  opacity: 0; /* Initially hide the text */\n  transform: translateX(-100%); /* Start off-screen to the left */\n  animation: slideInFromSide 3s ease-in-out forwards;\n}\n\n.markdown-content * {\n  font-weight: normal;\n  font-size: 14px; /* Adjust the size as needed */\n  /* Add other styles as needed */\n}\n\n.markdown-content a {\n  color: blue !important; /* Use !important to override other styles if necessary */\n  text-decoration: underline !important;\n}\n\n.message-input-container {\n  display: flex;\n  align-items: center; /* This vertically centers the children */\n}\n\n/* Add specific styles for bold text */\n.markdown-content strong,\n.markdown-content b {\n  font-weight: bold; /* This will ensure bold text is displayed correctly */\n}\n\n.markdown-content p {\n  margin-bottom: 1em; /* Adjust the value as needed to increase space */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
